<template>
  <v-switch
    :value="item.active"
    class="ma-2 pa-0 switch"
    hide-details
    inset
    @click.stop="toggleActive"
  />
</template>

<script>
export default {
  name: 'SwitchContent',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    toggleActive () {
      this.$emit('update-active', !this.item.active);
    }
  }
};
</script>
